import { Component, OnInit } from '@angular/core';
import { CategoryService } from '../services/category/category.service';
import { ActivatedRoute, NavigationExtras, ParamMap, Router } from '@angular/router';
import { ProductService } from "../services/product/product.service";
import { environment } from "../../environments/environment";

@Component({
  selector: 'app-promos',
  templateUrl: './promos.component.html',
  styleUrls: ['./promos.component.css']
})
export class PromosComponent implements OnInit {

 
  categories=[];
  fournisseurs=[];
  fournisseursAll:any;
  productByCategory;
  pageSize = 12;
  page;
  total;
  contentLoaded = false;
  listF1=[];
  listF2=[];
  listF3=[];
  listF3Filtre = [];
  defaultParent
  baseUrl = environment.baseUrl
  fileTitiles = {f1:"",f2:"",f3:""}
  checkedFournisseurs:any=[];
  startIndex = 1;
  totalPages = 0;
  itemsPerPage = 12;
  pageNumbers:any;
  constructor(private categoryService:CategoryService,private route: ActivatedRoute,private productService:ProductService,private router: Router) { }

  nextPage() {
    if (this.startIndex < this.totalPages) {
      this.startIndex++;
      const queryParams: NavigationExtras = {
        queryParams: {
          page: this.startIndex
        }
      };
      this.router.navigate([], queryParams);
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.loadData();
    }
  }

  previousPage() {
    if (this.startIndex > 1) {
      this.startIndex--;
      const queryParams: NavigationExtras = {
        queryParams: {
          page: this.startIndex
        }
      };
      this.router.navigate([], queryParams);
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.loadData();
    }
  }

  goToPage(pageNumber: number) {
    if (pageNumber >= 1 && pageNumber <= this.totalPages) {
      this.startIndex = pageNumber;
      const queryParams: NavigationExtras = {
        queryParams: {
          page: this.startIndex
        }
      };
      this.router.navigate([], queryParams);
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      this.loadData();
    }
  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {
    this.route.paramMap.subscribe((params: ParamMap) => {
      let idParam = params.get('id')
      this.productService.getProductsPromos(this.startIndex, this.itemsPerPage).subscribe(res => {
         this.productByCategory = res['products'];
         this.totalPages = Math.ceil(Number(res['total']) / this.itemsPerPage);
          if (this.totalPages > 10) {
            if (
              Number(this.startIndex) <= this.totalPages - 5 &&  Number(this.startIndex) > this.totalPages - 5 || 
              Number(this.startIndex) <= this.totalPages - 4 &&  Number(this.startIndex) > this.totalPages - 5 ||
              Number(this.startIndex) <= this.totalPages - 3 &&  Number(this.startIndex) > this.totalPages - 5 ||
              Number(this.startIndex) <= this.totalPages - 2 &&  Number(this.startIndex) > this.totalPages - 5 ||
              Number(this.startIndex) <= this.totalPages - 1 &&  Number(this.startIndex) > this.totalPages - 5 ||
              Number(this.startIndex) <= this.totalPages &&  Number(this.startIndex) > this.totalPages - 5
              ) {
              this.pageNumbers = [
                1, 2 , '...', this.totalPages - 4,  this.totalPages - 3,  this.totalPages - 2,  this.totalPages - 1,  this.totalPages
              ];
            } else {
              if (Number(this.startIndex) > 2) {
                this.pageNumbers = [
                  1, 2 , '...', this.startIndex, Number(this.startIndex)+1, Number(this.startIndex)+2, Number(this.startIndex)+3, Number(this.startIndex)+4, '...', this.totalPages - 1, this.totalPages
                ];
              } else {
                this.pageNumbers = [
                  this.startIndex, Number(this.startIndex)+1, Number(this.startIndex)+2, Number(this.startIndex)+3, Number(this.startIndex)+4, '...', this.totalPages - 1, this.totalPages
                ];
              }
            }
          } else {
            this.pageNumbers = Array.from({ length: this.totalPages }, (_, i) => i + 1);
          }

         this.fournisseursAll   = res['fournisseurs']
         this.total = this.productByCategory.length;
         this.contentLoaded = true;
       });
       
       this.categoryService.allCategories().subscribe(res =>{
        
         this.listF1=[];
         this.listF2=[];
         this.listF3=[];
         this.categories = Object.entries(res['categories']);
         this.formatDataCategories(this.categories);


         var categorySelected = this.listF3.filter(function(f3) {
           if (f3.id === idParam) {
             return f3;
           }
         });

         this.fileTitiles.f3 = categorySelected[0].titre

         this.filtreF3ByF2(categorySelected[0].parent);
         var lstF2Filtre = this.listF2.filter((f2)=>{
           if(f2.id == categorySelected[0].parent){
             return f2;
           }
         })
         this.fileTitiles.f2 = lstF2Filtre[0].titre

         var lstF1Filtre = this.listF1.filter((f1)=>{
           if(f1.id == lstF2Filtre[0].parent){
             return f1;
           }
         })

         this.fileTitiles.f1 = lstF1Filtre[0].titre

         this.listF2 = lstF2Filtre;
         this.defaultParent = lstF2Filtre[0].parent;

       })
    });
  }

  onPageChange(numPage: number) {
    this.page = numPage
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }


  changeMax(nbrProducts)
  {
    // this.pageSize = nbrProducts;
    this.itemsPerPage = nbrProducts;
    this.loadData();
  }

  filtreByFournisseur(event:any)
  {
    if (this.checkedFournisseurs.filter(f => f == event.target.value).length == 0) {
      this.checkedFournisseurs.push(event.target.value);
    }else{
      const index = this.checkedFournisseurs.indexOf(event.target.value);
      if (index > -1) {
        this.checkedFournisseurs.splice(index, 1);
      }
    }

    console.log( this.checkedFournisseurs);
    this.productService.getProductsPromos(this.startIndex, this.itemsPerPage).subscribe(res => {
      this.productByCategory = res['products'];
      if(this.checkedFournisseurs.length != 0){
        this.productByCategory = this.productByCategory.filter(f=>{
          if(this.checkedFournisseurs.includes(f.TSICOD4)){
            return f;
          }
        })
      }
    })

  }

  filtreF3ByF2(f2Id)
  {
    this.listF3Filtre = [];

    this.listF3Filtre = this.listF3.filter(function(f3) {
      if (f3.parent === f2Id) {
        return f3;
      }

    });

  }

  formatDataCategories(categories)
  {

    var objectTemp = {id:'',titre:'',categories:{},parent:null};
    for (let i = 0; i < categories.length; i++)
    {
      objectTemp = categories[i][1];
      objectTemp.id = categories[i][0];
      this.listF1.push(objectTemp);
    }

    var f2Temp;
    this.listF1.forEach(f1 => {
      f2Temp = Object.entries(f1.categorie);
      for (let i = 0; i < f2Temp.length; i++)
      {
        objectTemp = f2Temp[i][1];
        objectTemp.id = f2Temp[i][0];
        objectTemp.parent =  f1.id;
        this.listF2.push(objectTemp);
      }
    });

    var f3Temp;
    this.listF2.forEach(f2 => {

      if (f2.categories != undefined && f2.categories.length!=0  ) {

        f3Temp = Object.entries(f2.categories);

        for (let i = 0; i < f3Temp.length; i++)
        {
          objectTemp.titre = f3Temp[i][1];
          objectTemp.id = f3Temp[i][0];
          objectTemp.parent =  f2.id;
          this.listF3.push(objectTemp);
          objectTemp = {id:'',titre:'',categories:{},parent:null};
        }
      }
    });

  }


}
